import api from "./axios";

/**
 * Automation Rules API
 */

// Get all automation rules
export const getAutomationRulesApi = (params = {}) =>
  api.get("/automation/rules", { params });

// Get single automation rule
export const getAutomationRuleApi = (id) =>
  api.get(`/automation/rules/${id}`);

// Create automation rule
export const createAutomationRuleApi = (data) =>
  api.post("/automation/rules", data);

// Update automation rule
export const updateAutomationRuleApi = (id, data) =>
  api.put(`/automation/rules/${id}`, data);

// Delete automation rule
export const deleteAutomationRuleApi = (id) =>
  api.delete(`/automation/rules/${id}`);

// Toggle automation rule enabled/disabled
export const toggleAutomationRuleApi = (id) =>
  api.put(`/automation/rules/${id}/toggle`);

// Test automation rule
export const testAutomationRuleApi = (id) =>
  api.get(`/automation/rules/test/${id}`);

/**
 * Automation Logs API
 */

// Get automation logs
export const getAutomationLogsApi = (params = {}) =>
  api.get("/automation/logs", { params });

// Get logs for a specific lead
export const getLeadAutomationLogsApi = (leadId) =>
  api.get(`/automation/logs/lead/${leadId}`);

// Retry failed automation
export const retryAutomationApi = (logId) =>
  api.post(`/automation/logs/${logId}/retry}`);

/**
 * Automation Stats API
 */

// Get automation statistics
export const getAutomationStatsApi = (params = {}) =>
  api.get("/automation/stats", { params });

/**
 * Manual Trigger
 */

// Manually trigger an event
export const manualTriggerApi = (data) =>
  api.post("/automation/trigger", data);
